<template>
	<div class="xuanfu" :class="{'on': back == true}" ref="ball" id="moveDiv" @mousedown="down" @touchstart="down"
		@mousemove.stop.prevent="move" @touchmove.stop.prevent="move" @mouseup="end" @touchend="end" @click="onClick">
		<div class="yuanqiu">
			首页
		</div>
	</div>
</template>

<script>
	export default {
		name: 'floatBtn',
		data() {
			return {
				flags: false,
				moveDiv: '',
				position: {
					x: 0,
					y: 0
				},
				nx: '',
				ny: '',
				dx: '',
				dy: '',
				xPum: '',
				yPum: '',
				back: false,
				timer: '',
			};
		},
		created() {

		},
		mounted() {
			this.moveDiv = this.$refs.ball;
			console.log(this.moveDiv)
		},
		methods: {
			// 实现移动端拖拽
			down() {
				this.flags = true;
				var touch;
				if (event.touches) {
					touch = event.touches[0];
				} else {
					touch = event;
				}
				this.position.x = touch.clientX;
				this.position.y = touch.clientY;
				this.dx = this.moveDiv.offsetLeft;
				this.dy = this.moveDiv.offsetTop;
			},
			move() {
				if (this.flags) {
					var touch;
					if (event.touches) {
						touch = event.touches[0];
					} else {
						touch = event;
					}
					this.nx = touch.clientX - this.position.x;
					this.ny = touch.clientY - this.position.y;
					this.xPum = this.dx + this.nx;
					this.yPum = this.dy + this.ny;
					let LimitX =
						document.documentElement.clinetWidth || document.body.clientWidth;
					let limitY =
						document.documentElement.clientHeight || document.body.clientHeight;
					if (
						this.xPum < 0 ||
						this.yPum < 0 ||
						this.xPum > LimitX - this.moveDiv.offsetWidth ||
						this.yPum > limitY - this.moveDiv.offsetHeight
					) {
						return false;
					}
					this.moveDiv.style.left = this.xPum + 'px';
					this.moveDiv.style.top = this.yPum + 'px';
					//阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
					document.addEventListener(
						'touchmove',
						function() {
							event.preventDefault();
						},
						false
					);
				}
			},
			//鼠标释放时候的函数
			end() {
				this.flags = false;
			},
			onClick() {
				console.log(this.back);
				if (this.back == false) {
					this.back = true;
					setTimeout(() => {
						// 需要执行的代码
						this.back = false;
					}, 3000); // 定时时间
					return false;
				}

				this.$router.push({
					path: '/'
				})

				// this.$router.go(-1);//返回上一层
			}
		}
	};
</script>
<style lang="scss" scoped>
	.xuanfu {
		width: 26px;
		height: 26px;
		border-radius: 50%;
		box-shadow: 0 0 0 4px rgba(163, 163, 168, 0.6);
		position: fixed;
		right: -6px;
		top: 50px;
		text-align: center;
		line-height: 26px;
		z-index: 9999;
	}

	.yuanqiu {
		font-size: 10px;
		color: #aaa;
	}

	.on {
		right: 4px;
		background-color: rgba(163, 163, 168, 1.0);
		box-shadow: 0 0 0 4px rgba(163, 163, 168, 1.0);

		.yuanqiu {
			color: #fff;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/mode/floatBtn.vue